'use strict'

import axios from 'axios'

export default Plugin

const registerAxios = (vueInstance) => {
  // Full config:  https://github.com/axios/axios#request-config
  // axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
  // axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
  // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

  const config = {
    baseURL: '/',
    withCredentials: true, // Check cross-site Access-Control
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
      'Cache-Control': 'no-cache',
    },
  }

  const _axios = axios.create(config)

  _axios.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      return config
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )

  Plugin.install = function (vm, options) {
    vm.axios = _axios
    window.axios = _axios
    Object.defineProperties(vm.prototype, {
      axios: {
        get() {
          return _axios
        },
      },
      $axios: {
        get() {
          return _axios
        },
      },
    })
  }

  vueInstance.use(Plugin)
}

export { registerAxios }
